import { brandColors, productColors } from '@givebutter/util';
import { OnboardingChecklistItemStyleProps } from 'components/onboarding-checklist/onboarding-checklist-item/types';
import styled, { css } from 'styled-components';

const ChecklistItemText = styled.p`
    font-size: 18px;
    font-weight: 500;
`;

const ChecklistItemWrapper = styled.div<OnboardingChecklistItemStyleProps>`
    cursor: pointer;
    display: flex;
    column-gap: 1rem;
    align-items: center;
    padding: 1rem 1.5rem;

    &:hover {
        background-color: ${productColors.gray[50]};
    }

    ${({ interactive = true }) =>
        !interactive &&
        css`
            cursor: initial;

            &:hover {
                background-color: initial;
            }
        `}

    ${props =>
        props.isCompleted &&
        css`
            background-color: ${productColors.gray[50]};

            & ${ChecklistItemText} {
                text-decoration: line-through;
                color: ${productColors.gray[300]};
            }
        `};
`;

const IconWrapper = styled.div`
    height: 20px;
    width: 20px;

    & > svg {
        height: 100%;
        width: 100%;
    }
`;

const CheckableIconWrapper = styled(IconWrapper)<{ isCompleted: boolean }>`
    color: ${props => (props.isCompleted ? productColors.green[400] : brandColors.butter.primary)};
`;

const ChecklistItemChildrenWrapper = styled.div`
    flex: 2;
`;

const ChecklistArrowContainer = styled.div`
    color: ${productColors.gray[400]};
`;

export {
    ChecklistArrowContainer,
    ChecklistItemWrapper,
    CheckableIconWrapper,
    ChecklistItemText,
    IconWrapper,
    ChecklistItemChildrenWrapper,
};
